import {EndpointBuilder} from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import {IDownloadInvoiceDto, IEditInvoiceDto, IInvoice, IInvoiceDetails, ISendInvoiceDto} from '../interfaces/invoice';
import {enqueueSnackbar} from 'notistack';

export const type = 'invoice';
export const invoiceEndpoints = (builder: EndpointBuilder<any, any, any>) => ({
  // Get Invoice
  getInvoices: builder.query<IInvoice[], {documentId: string}>({
    query: (params) => ({
      url: '/invoices',
      method: 'GET',
      params
    }),
    transformResponse: (response) => {
      if (response?.detail || response?.error) {
        enqueueSnackbar(response?.detail || response?.description, {variant: 'error', preventDuplicate: true});
        return [];
      }
      return Array.isArray(response)
        ? response.map((item: { details: IInvoiceDetails[] }) => ({
          ...item,
          details: Array.isArray(item.details) ? item.details[0] : null
        }))
        : [] as any;
    }
  }),
  // Send Invoice
  sendInvoice: builder.mutation<IInvoice, ISendInvoiceDto>({
    query: (body) => ({
      url: '/invoices/send',
      method: 'POST',
      body
    })
  }),
  // Download Invoice
  downloadInvoice: builder.mutation<string, IDownloadInvoiceDto>({
    query: (body) => ({
      url: '/invoices/download',
      method: 'POST',
      body
    }),
    transformResponse: (response) => response as string
  }),
  // Edit Invoice
  editInvoice: builder.mutation<IInvoice, IEditInvoiceDto>({
    query: (body) => ({
      url: '/invoices/billing',
      method: 'PATCH',
      body
    }),
    transformResponse: (response) => response
  }),
});

export default invoiceEndpoints;
